// this hook manages a local user state with persistence in localStorage
import { useState, useEffect } from 'react';
import { LOCAL_STORAGE_KEY } from '../utils/constant';

const LOCAL_USER_KEY = LOCAL_STORAGE_KEY.LOCAL_USER_KEY;

export function useLocalUser() {
    const [localUser, setLocalUser] = useState<any>(null);

    useEffect(() => {
        const storedUser = localStorage.getItem(LOCAL_USER_KEY);
        if (storedUser) {
            setLocalUser(JSON.parse(storedUser));
        }
    }, []);

    const saveLocalUser = (user: any) => {
        localStorage.setItem(LOCAL_USER_KEY, JSON.stringify(user));
        setLocalUser(user);
    };

    const clearLocalUser = () => {
        localStorage.removeItem(LOCAL_USER_KEY);
        setLocalUser(null);
    };

    return {
        localUser,
        saveLocalUser,
        clearLocalUser,
    };
}
